export default __webpack_public_path__ + "static/media/477.f169b849.png";